import { useQuery } from '@tanstack/react-query';
import { PRICE_RULES_QUERY } from '../QueryKeys';
import { IPriceRule } from '../../types/price.types';
import { API_URL } from '../../api';
import { PRICE_SCHEME_HEADER, Status } from '../../api/constants';
import { fetch } from '../../api/fetchWrapper/fetch';

const getPriceRules = (priceSchemeId: string) => async () => {
  const res = await fetch(`${API_URL}/pricing/price-rules`, {
    headers: { [PRICE_SCHEME_HEADER]: priceSchemeId },
  });
  if (res.status !== Status.SUCCESS) {
    throw new Error('Unable to fetch price rules');
  }
  const json: IPriceRule[] = (await res.json()).data;
  return json;
};

export const useRules = (priceSchemeId: string) => {
  return useQuery({ queryKey: [...PRICE_RULES_QUERY, priceSchemeId], queryFn: getPriceRules(priceSchemeId) });
};
